// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({"1367": "ModelViewer","2257": "EthereumWallet","582": "NftSecondaryMarketModal","7530": "ActionToast","7581": "NftPdpZoomModal","8692": "RecentlyViewed",}[chunkId] || chunkId) + ".542.0.0." + {"1367": "0c0788f488be7a7b","2257": "c99e9767d020a68c","2973": "a77102e251e4d988","582": "d2af9a198e020c88","7530": "3333c744b982fe01","7581": "5998b29a6036295a","8692": "ff03095a48933e60",}[chunkId] + ".css"
}